/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { useState, useEffect } from 'react';
import { analyticsApi } from '../api/analytics';
import { AggregatedMarketData } from '../types/analytics';

export const useMarketAnalytics = (tokenMint?: string, symbol?: string) => {
    const [data, setData] = useState<AggregatedMarketData | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let mounted = true;

        const fetchData = async () => {
            if (!tokenMint || !symbol) return;
            
            setIsLoading(true);
            try {
                const result = await analyticsApi.getAggregatedTokenStats(tokenMint, symbol);
                if (mounted && result.success && result.data) {
                    setData(result.data);
                } else if (mounted) {
                    setError(result.error || "Failed to fetch market analytics");
                }
            } catch (e: any) {
                if (mounted) setError(e.message);
            } finally {
                if (mounted) setIsLoading(false);
            }
        };

        fetchData();
        // Poll every 30s
        const interval = setInterval(fetchData, 30000);

        return () => {
            mounted = false;
            clearInterval(interval);
        };
    }, [tokenMint, symbol]);

    return {
        marketData: data,
        isLoading,
        error
    };
};